/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import moment from "moment";
import 'moment-timezone';

export const monthList = [
  { value: 1, name: "January", days: 31 },
  { value: 2, name: "February", days: 28 },
  { value: 3, name: "March", days: 31 },
  { value: 4, name: "April", days: 30 },
  { value: 5, name: "May", days: 31 },
  { value: 6, name: "June", days: 30 },
  { value: 7, name: "July", days: 31 },
  { value: 8, name: "August", days: 31 },
  { value: 9, name: "September", days: 30 },
  { value: 10, name: "October", days: 31 },
  { value: 11, name: "November", days: 30 },
  { value: 12, name: "December", days: 31 },
];

export const unixEpochToString = ({
  timestamp,
  showTime = true,
  timezone = null,
  format = null
}) => {
  // handle null
  if (timestamp == null) {
    return null;
  }

  // convert Unix timestamp to milliseconds
  const date = new Date(timestamp * 1000);

  // create moment object and apply timezone
  let momentObj = moment(date);
  if (timezone) {
    momentObj = momentObj.tz(timezone);
  }

  // convert to human-readable date string
  if (format) {
    return momentObj.format(format);
  }
  
  const dateString = momentObj.format(showTime ? "M/D/yy h:mm A" : "M/D/yy");

  return dateString;
};

export const formatDate = (day, month, year) => {
  if (!day|| !month || !year) {
    return null;
  }

  // add leading 0s to each value
  const formattedDay = String(day).padStart(2, '0');
  const formattedMonth = String(month).padStart(2, '0');
  const formattedYear = String(year).padStart(4, '0');

  // build and return date in yyyy/mm/dd format
  const formattedDate = `${formattedYear}/${formattedMonth}/${formattedDay}`;
  return formattedDate;
};

export const parseDate = (dateString) => {
  // split date and validate
  const dateSplit = dateString?.split("/");
  if (dateSplit == null || dateSplit.length !== 3) {
    return null;
  }

  // parse out year/month/day
  return {
    day: parseInt(dateSplit[2]),
    month: parseInt(dateSplit[1]),
    year: parseInt(dateSplit[0]),
  };
};
